import { StyleSheet } from 'react-native';

import {
  SPOT_LEGEND_SPACER_MARGIN_TOP,
  SPOT_LEGEND_SPACER_PADDING_BOTTOM,
  SPOT_LEGEND_SPACER_PADDING_HORIZONTAL
} from './spotGridLegendReserve';

export const styles = StyleSheet.create({
  container: {
    width: '100%'
  },
  containerPinchZoom: {
    flex: 1
  },
  /** Wraps grid + legend so the scroll tutorial overlay can be positioned on top */
  contentWithOverlay: {
    position: 'relative',
    width: '100%'
  },
  contentWithOverlayPinchZoom: {
    flex: 1,
    justifyContent: 'flex-start',
    minHeight: 0
  },
  /** Wraps the horizontal ScrollView so it only takes screen width; content (grid) can be wider */
  gridScrollContainer: {
    width: '100%'
  },
  gridZoomHorizontalScroll: {
    flexGrow: 1,
    width: '100%'
  },
  gridZoomSlot: {
    flexGrow: 1,
    flexShrink: 1,
    minHeight: 0,
    width: '100%'
  },
  /** Pinch grid in a parent ScrollView: natural height, legend scrolls below the grid slot. */
  gridZoomSlotPageScroll: {
    width: '100%'
  },
  gridZoomViewport: {
    flexGrow: 1,
    flexShrink: 1,
    minHeight: 0,
    overflow: 'hidden',
    width: '100%'
  },
  /** Pre-measurement pinch viewport: fill the slot so nested flex:1 views get a real height. */
  gridZoomViewportFill: {
    flexGrow: 1,
    flexShrink: 1,
    minHeight: 0,
    overflow: 'hidden'
  },
  /**
   * When the trimmed grid is narrower than the viewport, center it horizontally; when wider,
   * flexGrow + minWidth do not shrink the scrollable area so horizontal scrolling still works.
   */
  horizontalScrollContent: {
    flexGrow: 1,
    justifyContent: 'center',
    minWidth: '100%'
  },
  /**
   * Space between grid and legend; extra bottom padding so embedded UIs with a fixed bottom
   * action (e.g. member app spot booking) do not crowd the legend.
   */
  legendSpacer: {
    marginTop: SPOT_LEGEND_SPACER_MARGIN_TOP,
    paddingBottom: SPOT_LEGEND_SPACER_PADDING_BOTTOM,
    paddingHorizontal: SPOT_LEGEND_SPACER_PADDING_HORIZONTAL
  }
});
